type Listener = () => void;

export const calculateUploadProgress = (loaded: number, total?: number): number => {
    return Math.floor((loaded * 100) / (total || 1));
};

export class ProgressManager {
    private progresses: Record<string, number> = {};
    private silentIds = new Set<string>();
    private listeners: Listener[] = [];

    subscribe(listener: Listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter((l) => l !== listener);
        };
    }

    addProgress(id: string, { showText = true }: { showText?: boolean } = {}) {
        if (!showText) this.silentIds.add(id);
        if (!this.progresses[id]) {
            this.progresses[id] = 0;
            this.notify();
        }
    }

    updateProgress(id: string, value: number) {
        if (this.progresses[id] !== value) {
            this.progresses[id] = value;
            this.notify();
        }
    }

    reset() {
        this.progresses = {};
        this.notify();
    }

    getProgresses() {
        return Object.values(this.progresses);
    }

    shouldShowText() {
        return Object.keys(this.progresses).some((id) => !this.silentIds.has(id));
    }

    getAverage() {
        const values = this.getProgresses();
        if (!values.length) return 0;
        return Math.floor(values.reduce((a, b) => a + b, 0) / values.length);
    }

    private notify() {
        this.listeners.forEach((listener) => listener());
    }
}

export const progressManager = new ProgressManager();
